<template>
    <div id="offertool">
        <div id="offertool" v-show="userLoaded && themeLoaded">
            <div class="content">
                <transition appear enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in" >
                    <router-view></router-view>
                </transition>
            </div>
        </div>
        <template v-if="!userLoaded || !themeLoaded">
            <div id="page-loader" class="container">
                <div class="text-center">
                    <font-awesome-icon icon="spinner" pulse />
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'app',
  computed: {
    userLoaded () {
      return  this.$store.getters.getUserLoaded;
    },
    themeLoaded () {
      return true;

      //let obj = this.$store.getters.getTheme
      //return !(Object.keys(obj).length === 0 && obj.constructor === Object)
    }
  },
  beforeCreate () {
    if (!this.$store.getters.getUserLoaded) {
      this.$store.dispatch('loadUser')
    }
  }
}
</script>

<style lang="scss">
#page-loader {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
